"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonDesktopComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var hooks_1 = require("../hooks");
var utils_1 = require("../utils");
var NonDesktopComponent = function (_a) {
    var children = _a.children;
    var screenSize = (0, hooks_1.useScreenSize)().screenSize;
    if (screenSize === utils_1.ScreenSize.Desktop) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.NonDesktopComponent = NonDesktopComponent;
